export default "__VITE_ASSET__Av51BSCe__"